import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import React from 'react';

const ReviewAnswerFieldTextType = ({ label, value }) => {
  return (
    <React.Fragment>
      <Row style={{ marginBottom: '10px', marginTop: '10px' }} gutter={16}>
        <Col span={10}>
          <span> {label}</span>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ReviewAnswerFieldTextType;
